import { useState } from 'react';
import { Grid, IconButton } from '@mui/material';

// COMPONENTES
import MiTabla from '../../../components/plantilla/tabla/MiTabla';
import AtenderAlerta from './modales/AtenderAlerta';
import DetallesAlerta from './modales/DetallesAlerta';

// ICONOS
import EmailIcon from '@mui/icons-material/Email';
import InfoOutlineIcon from '@mui/icons-material/InfoOutline';

const Historial = ({ events }) => {

    const [selectedRow, setSelectedRow] = useState(null);
        
    const [isOpen, setIsOpen] = useState({
        editar: false,
        detalles: false,
    });

    const handleClickView = (row) => {

        setSelectedRow(row);
        setIsOpen({ ...isOpen, detalles: true });

    }

    const handleClickEdit = (row) => {

        setSelectedRow(row);
        setIsOpen({ ...isOpen, editar: true });

    }

    // =========================================
    // COLUMNAS
    // =========================================

    const columns = [

        { 
            field: 'event_type', 
            headerName: 'Incidencia',
            flex: 1,
            headerAlign: "center",
            align: "center",
        },
        { 
            field: 'driver_name', 
            headerName: 'Conductor',
            flex: 1,
            headerAlign: "center",
            align: "center",
        },
        { 
            field: 'truck', 
            headerName: 'Unidad',
            flex: 1,
            headerAlign: "center",
            align: "center",
        },
        { 
            field: 'attended_by', 
            headerName: 'Atendio:',
            flex: 1,
            headerAlign: "center",
            align: "center",
        },
        { 
            field: 'event_date', 
            headerName: 'Fecha',
            flex: 1,
            headerAlign: "center",
            align: "center",
        },
        { 
            field: 'tiempo_respuesta', 
            headerName: 'Tiempo Respuesta',
            flex: 1,
            headerAlign: "center",
            align: "center",
        },
        { 
            field: '', 
            headerName: '',
            flex: 1,
            headerAlign: "center",
            align: "center",
            renderCell: (params) => {

                return (

                    <>
                        <IconButton 
                            color="info"
                            onClick={() => handleClickView(params.row)}
                        >
                            <EmailIcon/>
                        </IconButton>
                        <IconButton 
                            color="warning"
                            onClick={() => handleClickEdit(params.row)}
                        >
                            <InfoOutlineIcon/>
                        </IconButton>
                    </>

                )

            }
        },

    ];

    return (

        <Grid container>

            <Grid size={12}>

                <MiTabla 
                    columns={columns}
                    data={events}
                    // onRowClick={handleClick}
                />

            </Grid>

            {/* MODAL PARA ATENDER ALERTA */}

            <AtenderAlerta
                open={isOpen.editar}
                onClose={() => setIsOpen(false)}
                data={selectedRow}
            />

            {/* MODAL PARA DETALLES ALERTA */}

            <DetallesAlerta
                open={isOpen.detalles}
                onClose={() => setIsOpen({ ...isOpen, detalles: false })}
                data={selectedRow}
            />

        </Grid>

    )
    
}

export default Historial